module.exports = __webpack_public_path__ + "static/media/step4-top.e9b0d599.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step4-top.png
// module id = 3741
// module chunks = 0